import { pick } from 'lodash-es'
import { useTbViewStore } from '@vt/hooks'

const useArticleDetail = function () {
  const { articleConfig, detailConfig } = useTbViewStore((state) =>
    pick(state, ['articleConfig', 'detailConfig'])
  )
  // 优先获取detailConfig中的配置
  const main =
    (detailConfig && detailConfig.main) || (articleConfig && articleConfig.main)
  const side =
    (detailConfig && detailConfig.side) || (articleConfig && articleConfig.side)
  const { isShowDetailTop, isShowDetailRight, link, size } = main || {}

  /** 是否隐藏顶部信息 */
  // const isHiddenDetailTop = main.isHiddenDetailTop
  /** 是否隐藏右侧信息 */
  // const isHiddenDetailRight = main.isHiddenDetailRight
  /** 图片位置 */
  const imagePosition = main.image && main.image.position
  /** 用来判断是否显示文章标题，以及存放的slug */
  const titleSlug = main.title && main.title.slug
  /** 用来判断是否显示文章内容，以及存放的slug */
  const summarySlug = main.summary && main.summary.slug
  /** 用来判断是否显示avatar，以及存放的slug */
  // const avatarSlug = false
  /** 用来判断是否显示作者名称，以及存放的slug */
  const createBySlug = main.createdBy && main.createdBy.slug
  /** 用来判断是否显示时间，以及存放的slug */
  const dateSlug = main.date && main.date.slug
  /** 用来判断是否显示image，以及存放的slug */
  const imageSlug = main.image && main.image.slug
  /** 用来判断是否显示file，以及存放的slug */
  const fileSlug = main.file && main.file.slug
  /** 主列表-底部在一行显示的内容（点赞、评论..） */
  const bottomField_main = main.fields

  /** 是否显示其他文章 */
  const isShowSide = side && side.show

  /** 是否显示翻译按钮 */
  const isShowTranslate = main && main.translate && main.translate.show

  /**
   * 将数字转换为千位分隔符
   * @param {*} num
   * @returns
   */
  const toThousands = (num) => {
    return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  }

  return {
    isShowDetailTop,
    isShowDetailRight,
    imagePosition,
    titleSlug,
    summarySlug,
    createBySlug,
    dateSlug,
    imageSlug,
    fileSlug,
    link,
    size,
    bottomField_main,
    isShowSide,
    isShowTranslate,
    toThousands,
  }
}
export default useArticleDetail
